// POROS screen help (the "?" at the top of POROS). Plain words; keep it in step with
// the screen in tools/PorosTool.tsx.
import type { ScreenHelpContent } from '../../v10/ScreenHelp';

export const porosHelp: ScreenHelpContent = {
  title: 'POROS',
  intro:
    'POROS answers one question about one objective: "Do I have everything I need to accomplish this objective?" You list what you need, tick what you already have, and POROS shows how ready you are.',
  sections: [
    {
      heading: 'Pick an objective',
      body: [
        "If you open POROS from the orb, it already has your objective. If it has none, type one into \"What's the objective?\", choose which area of life it belongs to, and press Check readiness. Next time, POROS reopens the last objective you used on this phone.",
      ],
    },
    {
      heading: 'The top card',
      items: [
        { term: 'Objective', text: 'the thing you want to accomplish, in large letters.' },
        { term: 'x of y required resources ready', text: 'how many things on your list you have ticked. It says "No resources listed yet" until you add something.' },
        { term: 'READY / NOT READY', text: 'READY (green) means every listed resource is ticked. NOT READY (orange) means something is still missing.' },
        { term: 'Bar', text: 'fills up as you tick resources.' },
      ],
    },
    {
      heading: 'The six categories',
      body: ['Think about what you need in each of these. A resource is just one short line of text.'],
      items: [
        { term: 'People', text: 'who you need.' },
        { term: 'Places', text: 'where it needs to happen.' },
        { term: 'Products', text: 'physical or digital things.' },
        { term: 'Processes', text: 'procedures or methods.' },
        { term: 'Prerequisites', text: 'things that must already be true or done first.' },
        { term: 'Parameters', text: 'limits you can measure: time, budget, amounts, deadlines.' },
      ],
    },
    {
      heading: 'How to use it',
      body: [
        'Press Add next to a category, then type the resource where it says "Resource…".',
        'Tick the circle only when you really have it. Untick it if you lose it.',
        'Press the X on a resource to remove it.',
        'Don\'t need a whole category? Flip its switch to "Not needed". Its resources stay saved, but they stop counting towards your total. Pressing Add turns the category back on.',
      ],
    },
    {
      heading: 'Auto-fill',
      body: [
        'Press "✦ Auto-fill what this usually needs" and POROS suggests typical resources for your objective. They arrive unticked, so you still decide what you have. Categories POROS thinks you don\'t need are switched to "Not needed". Delete or edit anything that doesn\'t fit.',
      ],
    },
    {
      heading: 'Saving',
      body: ['There is no Save button. Every change saves by itself a moment after you make it. The same objective always brings back the same list.'],
    },
  ],
};
